import { axios, getAxiosConfig } from '../utils/apiUtils';
import React, { useState, useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { setSession } from '../utils/authUtils'

import { useTranslation } from 'react-i18next';
import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap';
import PasswordRecovery from '../components/passwordRecovery';

import logoChungungo from '../assets/images/logotipo-chungungo-flor.svg';
import '../main.css';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 12 },
};

const styles = {
  alert: {
    marginTop: '16px',
    marginBottom: '16px',
  },
  layout: {
    paddingTop: '30vh',
    marginLeft: 'auto',
    marginRight: 'auto',
    height: '100vh',
    backgroundColor: 'white',
  },
  button: {
    margin: '16px',
    width: '100%'
  },
  form: {
    width: '100%',
  }
}

const Login = () => {
  let { giftId } = useParams();
  const { t, i18n } = useTranslation();

  const [user, setUser] = useState();
  const [password, setPassword] = useState();

  const [showError, setShowError] = useState();
  const [showPasswordRecovery, setShowPasswordRecovery] = useState();

  const [goToVideoList, setGoToVideoList] = useState();
  const [goToRegister, setGoToRegister] = useState();

  const [giftData, setGiftData] = useState();

  const getGiftData = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/payments/gifts/mercadopago/temp_user/${giftId}`,
      getAxiosConfig(),
    )
      .then((giftResponse) => {
        setGiftData(giftResponse.data);
      })
      .catch(console.error);
  }

  useEffect(
    () => {
      getGiftData();
    },
    [],
  );

  const startChungungoSession = (event) => {
    event.preventDefault();

    const loginData = {
      email: user,
      password: password,
    };

    if (giftId) {
      loginData['giftId'] = giftId;
    }

    axios.post(
      `${process.env.REACT_APP_API_URL}/auth/login`,
      loginData,
      {
        headers: { 'Content-Type': 'application/json' }
      },
    ).then((loginResponse) => {
      const userFromServer = loginResponse.data;

      setSession(userFromServer);

      setGoToVideoList(true);
    }).catch(() => {
      setShowError(true);
    });
  }

  if (goToVideoList) {
    return (<Redirect to="/seasons" push />);
  }

  if (goToRegister) {
    return (<Redirect to="/register" push />);
  }

  return (
    <div 
      id="login"
      className="text-center"
    >
      {showPasswordRecovery &&
        <PasswordRecovery onClose={(event) => setShowPasswordRecovery(false)} user={user} />
      }
      <Form
        className="form-signin"
        onSubmit={startChungungoSession}
      >
        <h1><img class="mb-4" src={logoChungungo} alt="" width="190" height="" /></h1>
        {showError &&
          <div class="alert alert-danger" role="alert">
            {t('login.alert.noauth')}
          </div>
        }
        {giftData && giftData.isUsed === false &&
          <div class="alert alert-success" role="alert">
            Tienes un regalo, al hacer login este se activará en tu cuenta
          </div>
        }
        <label for="inputEmail" class="sr-only">Correo</label>
        <input className="form-control" type="text" id="user" placeholder="Correo electrónico" value={user} onChange={(evt) => setUser(evt.target.value)} />
        <label for="inputPassword" class="sr-only">Contraseña</label>
        <input className="form-control" type="password" id="password" placeholder="Contraseña" password={password} onChange={(evt) => setPassword(evt.target.value)} />
        <div class="checkbox mb-3">
            <a class="cursor-pointer" href="/recover_password">Olvidé mi contraseña</a>
        </div>
        <button class="btn btn-lg btn-primary btn-block" type="submit">Entrar</button>
        <div class="checkbox mt-2 mb-4">
          <a href="/register">¿No tienes cuenta? Regístrate</a>
        </div>
      </Form>
    </div>
  );
};

export default Login;